import { useContext, useEffect, useState } from 'react';
import { makeStyles, TextField, InputLabel, Select, FormControl, MenuItem, StepButton} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import StepContent from '@material-ui/core/StepContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import { dateToStr } from '../../../utils/DateUtils';
import clsx from 'clsx';
import { NoneArrow, separations } from '../../../constants/StyleConstants';
import CustomDatePicker from '../../../components/UI/CustomDatePicker';
import { CLAIM_STATUS } from '../ClaimManagementPresenter';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import UpdateOutlinedIcon from '@material-ui/icons/UpdateOutlined';
import { InventoriesContext } from '../../../contexts/InventoriesContext';
import FileLoader from '../../../components/UI/FileLoader'
import ClaimsAPI from '../../../services/ClaimsAPI';
import { decodeFile, decodeFileView } from '../../../utils/MiscellaneousUtils';
import ClaimNewDerivation from './ClaimNewDerivation';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  rootRead: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  formControl: {
    minWidth: 120,
  },
  topSeparation: {
    marginTop: 8,
  },
  newDerivation: {
    marginTop: '3%',
  },
  rigthSeparation: {
    marginRight: 10,
  },
  baseAlignment: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  statusInputControl: {
    '& .MuiSelect-select.MuiSelect-select': {
      display: 'flex',
      alignItems: 'flex-end',
      columnGap: '.5em',
    },
  },
  stepTitle: {
    fontWeight: 'bold',
  },
  stepDate: {
    opacity: '.6',
  },
  pdf:{
    position: 'absolute',
    right: '0px',
    width: '70%',
    height: '100%',
    flexdirection: 'column',
    alignitems: 'center',
    justifycontent: 'center',
    fontsize: 'calc(10px + 2vmin)',
    scrollbarcolor: 'red yellow',
    //overflow: 'hidden',
    /*backgroundColor:'#282c34',
    color: 'white',*/
  },
  detail:{
    position: 'absolute',
    display:'grid',
    left: '0px',
    width: '29%',
    height: '98%',
    overflow: 'auto',
    
  },
  detailRead:{
    position: 'absolute',
    display:'grid',
    left: '0px',
    width: '100%',
    height: '98%',
    overflow: 'auto',
    
  }
}));

const ClaimDetails = ({ item, setNewDeri, readOnly }) => {
  const classes = useStyles();
  const { getTheAreas, getTheClaimTypes } = useContext(InventoriesContext);
  const [lastArea, setLastArea] = useState({});
  const [claimType, setClaimType] = useState({});
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [urlPdf, setUrlPdf] = useState('');

  const [activeStep, setActiveStep] = useState(null);
  const [stepsAreas, setStepsAreas] = useState([]);
  const [steps, setSteps] = useState([]);

  const [newDerivation, setNewDerivation] = useState({});

  const handleFiles = files => {
    setAttachedFiles([...attachedFiles, ...files]);
  };

  const handleDownloadFile = (id, fileName) => {
    return ClaimsAPI.getFile(id, fileName)
      .then(res => 
        decodeFile(res, fileName),
        setOpen(true))
      .catch(error => console.log('Error inesperado'));
  };
  const handleViewFile = (id, fileName) => {
    return ClaimsAPI.getFile(id, fileName)
      .then(res =>  
        setUrlPdf(decodeFileView(res, fileName)),
        setOpen(true))
      .catch(error => console.log('Error inesperado'));
  };

  useEffect(() => {
    getTheAreas().then(res => setLastArea(res.find(area => area.id === item?.derivations?.last().idArea)));
    getTheAreas().then(res => setStepsAreas(res));
    getTheClaimTypes().then(res => setClaimType(res.find(ct => ct.id === item?.idType)));
    setAttachedFiles(item?.files);
    setSteps(item?.derivations)
  }, [item]);

  setNewDeri(newDerivation);

  return (
    <div className={classes.root }>
      {readOnly?'':
      <div className={classes.pdf}>
        {<FileLoader 
        data={attachedFiles}
        viewFile={fileName => handleViewFile(item.id, fileName)} 
        action={fileName => handleDownloadFile(item.id, fileName)} 
        open={open} 
        url={urlPdf}
        />}
      </div>
      }
      <div className={readOnly? classes.detailRead:classes.detail}>
          <h3>Detalles</h3>
          <TextField margin="dense" inputProps={{ readOnly: true }} id="razonSocial" label="CUIT/Razón Social" value={item?.supplier || ''} />
          <TextField
            margin="dense"
            inputProps={{ readOnly: true }}
            id="claimType"
            label="Tipo de reclamo"
            value={claimType?.name || 'Cargando tipo de reclamo...'}
          />
          <TextField
            className={classes.topSeparation}
            margin="dense"
            inputProps={{ readOnly: true }}
            id="description"
            multiline
            rows={4}
            variant="outlined"
            label=" Descripción "
            value={item?.description || ''}
          />
          <CustomDatePicker value={item?.startDate} label="Fecha de alta" readOnly margin="dense" />
          <TextField margin="dense" inputProps={{ readOnly: true }} id="derived" label="Derivado" value={lastArea?.name || ''} />
          <div className={clsx(classes.separationBetween, classes.baseAlignment, classes.topSeparation)}>
            <div>
              <FormControl className={clsx(classes.formControl)} margin="dense">
                <InputLabel id="select-state-label">Estado</InputLabel>
                <Select
                  IconComponent={NoneArrow}
                  className={classes.statusInputControl}
                  margin="dense"
                  labelId="select-state-label"
                  id="state-select"
                  inputProps={{ readOnly: true }}
                  value={item?.state == true}>
                  <MenuItem className={classes.statusOption} value={true}>
                    {CLAIM_STATUS.OPEN}
                    <UpdateOutlinedIcon color="secondary" />
                  </MenuItem>
                  <MenuItem className={classes.statusOption} value={false}>
                    {CLAIM_STATUS.CLOSED}
                    <CheckCircleOutlinedIcon color="primary" />
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            {item?.state == 0 && (
              <CustomDatePicker
                value={item?.endDate}
                label="Fecha de cierre"
                readOnly
                margin="dense"
                disabled={!item?.endDate}
                style={{ width: 150 }}
              />
            )}
          </div>
          <TextField
            className={classes.topSeparation}
            margin="dense"
            inputProps={{ readOnly: true }}
            id="response"
            multiline
            rows={4}
            variant="outlined"
            label="Respuesta"
            value={item?.reply || ''}
          />
          {readOnly?'':
            <div className={classes.newDerivation}>
              <h3>Nueva Derivación</h3>
              <ClaimNewDerivation setNewDerivation={setNewDerivation} />      
            </div>
          }
        {<div className={classes.topSeparation}>
          <h3>Derivaciones</h3>
          <Stepper className={classes.root} activeStep={activeStep} orientation="vertical" nonLinear>
            {steps?.map((step, index) => (
              <Step key={index}>
                <StepButton onClick={() => setActiveStep(index)}>
                  <span className={classes.stepTitle}>{stepsAreas.find(area => area.id === step.idArea)?.name}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className={classes.stepDate}>{dateToStr(step.derivatedDate)}</span>
                </StepButton>
                <StepContent>
                  <Typography style={{ whiteSpace: 'pre-wrap' }}>{step.observation}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </div>}
        
      </div>
    </div>
  );
};

export default ClaimDetails;
